export const Blueprints = (flujax) => ({
  async fetchLockableFields () {
    return flujax.post('/object/getLockableFieldsByType')
  },
  async createNewDynamicTagInGoogleSheet (name, blueprintId) {
    return flujax.post(`/template/getOrAttachSheet?sheetName=${name}&contentTemplateId=${blueprintId}`)
  },
  async googleSheetRequestAccess (payload) {
    return flujax.post('/template/dataSource/requestOpen', payload)
  },
  async snippetPreview (embedIds, payload) {
    return flujax.post(`/template/merge/preview?embedIds=${embedIds}`, payload)
  },
  async snippetApply (embedIds, payload) {
    return flujax.post(`/template/merge/apply?embedIds=${embedIds}`, payload)
  },
  async videoActionCampaignsPreview (contentTemplateId) {
    return flujax.post(`/template/vac/preview?contentTemplateId=${contentTemplateId}`)
  }
})
